"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const redux_observable_1 = require("redux-observable");
const typescript_fsa_1 = __importDefault(require("typescript-fsa"));
const enums_1 = require("./enums");
const reducerWithImmer_1 = require("./reducerWithImmer");
exports.initialState = {
    /**
     * GameView をメインパネルより手前に持ってくる
     */
    bringGameFront: true,
    /**
     * メインパネルのモード
     */
    editorMode: enums_1.EditorMode.Map
};
const actionCreator = typescript_fsa_1.default('gamebook');
exports.actions = {
    setEditorMode: actionCreator('SET_EDITOR_MODE'),
    bringGameFront: actionCreator('BRING_GAME_FRTON')
};
const mode = reducerWithImmer_1.reducerWithImmer(exports.initialState)
    .case(exports.actions.setEditorMode, (draft, payload) => {
    draft.editorMode = payload;
})
    .case(exports.actions.bringGameFront, (draft, payload) => {
    draft.bringGameFront = payload;
})
    .toReducer();
exports.default = mode;
exports.reducers = {
    mode
};
exports.epic = redux_observable_1.combineEpics();
